import $ from 'jquery';

loadMap();
export default function loadMap() {
    function initMap() {
        const mapContainer = $('#ad_gmap');
        if(!mapContainer.length) return;
        const longlat = $(mapContainer).attr('data-longlat').split(', ');
        const advertTypeData = $(mapContainer).attr('data-advert');
        const title = $(mapContainer).attr('data-title');

        const imagePinLarge = new google.maps.MarkerImage('/dist/images/noncode-dev.png',
            // This marker is 129 pixels wide by 42 pixels tall.
            null, // new google.maps.Size(80, 81),
            // The origin for this image is 0,0.
            null, // new google.maps.Point(0, 0),
            // The anchor for this image is the base of the flagpole at 18,42.
            null, // new google.maps.Point(39, 78),
            new google.maps.Size(60, 80));

        // Define Marker properties
        const imagePinCodeLarge = new google.maps.MarkerImage('/dist/images/code-dev.png',
            // This marker is 129 pixels wide by 42 pixels tall.
            null, // new google.maps.Size(80, 81),
            // The origin for this image is 0,0.
            null, // new google.maps.Point(0, 0),
            // The anchor for this image is the base of the flagpole at 18,42.
            null, // new google.maps.Point(39, 78),
            new google.maps.Size(60, 80));

        // Define Marker properties
        const imagePinCodeLargeUnipol = new google.maps.MarkerImage('/dist/images/pin-unipol-dev.png',
            // This marker is 129 pixels wide by 42 pixels tall.
            null, // new google.maps.Size(80, 81),
            // The origin for this image is 0,0.
            null, // new google.maps.Point(0, 0),
            // The anchor for this image is the base of the flagpole at 18,42.
            null, // new google.maps.Point(39, 78),
            new google.maps.Size(60, 80));

        // Define Marker properties
        const imagePinCodeUnipol = new google.maps.MarkerImage('/dist/images/pin-unipol-2.png',
            // This marker is 129 pixels wide by 42 pixels tall.
            null, // new google.maps.Size(80, 81),
            // The origin for this image is 0,0.
            null, // new google.maps.Point(0, 0),
            // The anchor for this image is the base of the flagpole at 18,42.
            null, // new google.maps.Point(39, 78),
            new google.maps.Size(60, 80));

        // Define Marker properties
        const imagePinCode = new google.maps.MarkerImage('/dist/images/code.png',
            // This marker is 129 pixels wide by 42 pixels tall.
            null, // new google.maps.Size(80, 81),
            // The origin for this image is 0,0.
            null, // new google.maps.Point(0, 0),
            // The anchor for this image is the base of the flagpole at 18,42.
            null, // new google.maps.Point(39, 78),
            new google.maps.Size(60, 80));

        const imagePinStandard = new google.maps.MarkerImage('/dist/images/noncode.png',
            // This marker is 129 pixels wide by 42 pixels tall.
            null, // new google.maps.Size(80, 81),
            // The origin for this image is 0,0.
            null, // new google.maps.Point(0, 0),
            // The anchor for this image is the base of the flagpole at 18,42.
            null, // new google.maps.Point(39, 78),
            new google.maps.Size(60, 80));


        let ad_markerIcon;
        const advertType = advertTypeData;

        $(() => {
            switch (advertType) {
                case 'Large Development':
                    ad_markerIcon = imagePinLarge;
                    break;
                case 'Code Large Development':
                    ad_markerIcon = imagePinCodeLarge;
                    break;
                case 'Unipol Large Development':
                    ad_markerIcon = imagePinCodeLargeUnipol;
                    break;
                case 'Unipol Housing':
                    ad_markerIcon = imagePinCodeUnipol;
                    break;
                case 'Unipol Code':
                    ad_markerIcon = imagePinCode;
                    break;
                default:
                    ad_markerIcon = imagePinStandard;
            }

            const zoom = 17;
            const center = new google.maps.LatLng(longlat[0], longlat[1]);
            const ad_mapOptions = {
                zoom,
                center,
                mapTypeId: google.maps.MapTypeId.ROADMAP,
                streetViewControl: false
            };
            const ad_map = new google.maps.Map(document.getElementById('ad_gmap'), ad_mapOptions);

            const ad_originMarker = new google.maps.Marker({
                position: center,
                map: ad_map,
                icon: ad_markerIcon
            });

            // Wire up the infoWindow click handler
            google.maps.event.addListener(ad_originMarker, 'click', (function (originMarker) {
                return function () {
                    infowindow.setContent(`<p><strong>${title}</strong></p>`);
                    infowindow.open(ad_map, originMarker);
                };
            }(ad_originMarker)));

            const infowindow = new google.maps.InfoWindow();
        });
    };

    function loadGmapScript() {
        const s = document.createElement('script');
        s.type = 'text/javascript';
        s.src = 'https://maps.googleapis.com/maps/api/js?v=3.exp&key=AIzaSyDspHUe2de80pCPqYy9-scfmRzTdaZpZ90&libraries=places&callback=initAdvertMap';
        $('head').append(s);
    }

    window.initAdvertMap = initMap;

    if (typeof google === 'object' && typeof google.maps === 'object') {
        initMap();
    } else {
        loadGmapScript();
    }
}
